module.exports = "/images/vendor/flag-icon-css/flags/1x1/es.svg?afff247381e7ebe7d31b609f33eca644";